// extracted by mini-css-extract-plugin
export default {"media-drawer-collection":"MediaDrawerCollectionStyles_media-drawer-collection__rWHAf","hidden":"MediaDrawerCollectionStyles_hidden__5mJNS"};